import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { ConfigType } from '../../models/client.model';
import { IReserve, IAdditionalService } from '../../models/reserve.model';
import { IReserveShoppingCartItem, EntityDataType, IAdditionalServiceShoppingCartItem } from '../../models/shopping-cart.model';
import { UtilitiesProvider } from '../../providers/utilities';
import { IEntityObject } from '../../providers/reserves';
import { ReserveError } from '../../shared/errors/reserve.error';
import { AuthData } from '../../providers/auth';
import { AuthError } from '../../shared/errors/auth.error';
import { PaymentProvider } from '../../providers/payment';
import { toArray } from 'lodash';

@Component({
  selector: 'cart-reserve-item',
  templateUrl: 'cart-reserve-item.html'
})
export class CartReserveItemComponent implements OnInit, OnChanges {

  @Input() public config: ConfigType;
  @Input() public reserveItem: IReserveShoppingCartItem;
  public reserve: IReserve;
  public image: string;
  public showSessions = true;
  public modalLoadCtrlFlag = false;
  public modalLoadCtrl: any;

  constructor(
    public modalCtrl: ModalController,
    private utilities: UtilitiesProvider,
    private authService: AuthData,
    private paymentProvider: PaymentProvider
  ) { }

  public ngOnInit() { }

  public async ngOnChanges(changes: SimpleChanges) {
    if (changes.reserveItem) {
      this.reserveItem = changes.reserveItem.currentValue;
      const entity: IEntityObject = { eventId: this.reserveItem.eventId, type: this.reserveItem.type };
      const entityData = await this.getReserveData(entity, this.reserveItem.id);
      const { Reserve } = entityData;
      this.reserve = Reserve;
      this.image = await this.getImage(entityData, entity);
    }
  }

  public async getImage(entityData: EntityDataType, entity): Promise<string> {
    switch (entity.type) {
      case 'CommercialSample':
        return entityData.photos[0];

      case 'Event':
        return entityData.image;

      case 'Staff':
        const { idStaff, image } = entityData;
        if (!idStaff) return image;
        const staffData = await this.utilities.getStaffData(idStaff);
        if (!staffData) throw new ReserveError();
        const { photos } = staffData;
        if (!photos) return ''; // TODO: Return placheolder or null here
        return photos[0];
    }
  }

  public async getReserveData(entity: IEntityObject, id: string) {
    const entityData = await this.utilities.getEntityData(entity.type, id, entity.eventId);
    if (!entityData) throw new ReserveError(); // This line produces an error with a default message
    return entityData;
  }

  public onAddCalendar(config: ConfigType, saleCalendar, isMultipleCalendarsSameDay, isMultipleCalendars) {
    this.modalCtrl.create(
      'CalendarSelectorPage',
      { config, reserveItem: this.reserveItem, isMultipleCalendarsSameDay, isMultipleCalendars },
      { enableBackdropDismiss: false }
    ).present();
  }

  public openModalStaffReserve(config: ConfigType) {
    this.modalCtrl.create(
      'AditionalServiceReservePage',
      { config, reserveItem: this.reserveItem },
      { enableBackdropDismiss: false }
    ).present();
  }

  public toggleShowSessions() {
    this.showSessions = !this.showSessions;
  }

  public getCalendarData(id: string, reserve: IReserve) {
    if (!reserve) return null;
    return reserve.calendars[id];
  }

  public getTotalServices(services: IAdditionalServiceShoppingCartItem[]) {
    if (!services) return 0;
    return services.reduce((total, next) => total + next.sale_amount, 0);
  }

  public getReserveWithCalendarsPrice(reserve: IReserve, calendars: string[] = []) {
    if (calendars.length === 0) return reserve.price;
    return reserve.price * calendars.length;
  }

  public getServicesPrice(selectedServices: IAdditionalServiceShoppingCartItem[] = [], additionalServices: IAdditionalService[]) {
    return selectedServices.reduce((total, next, i) => {
      const services = toArray(additionalServices);
      const { price } = services.find(s => s.id === next.id);
      return total + price * next.sale_amount;
    }, 0);
  }

  public getUrl(value: string) {
    if (!value) return '';
    return `url('${value}')`;
  }

  public getUid(): string {
    const user = this.authService.getUser();
    if (!user) throw new AuthError();
    return user.uid;
  }

  public async onDeleteCalendar(calendarId: string) {
    const { sale_calendar, id } = this.reserveItem;
    const calendars = sale_calendar.filter(c => c !== calendarId);
    const uid = this.getUid();
    await this.paymentProvider.setReserveShoppingCartSaleCalendars(calendars, id, uid);
  }

  public get canShowCalendars(): boolean {
    if (!this.reserveItem) return false;
    return this.reserveItem.type !== 'Event';
  }

  public get canShowTotal(): boolean {
    if (!this.reserve || !this.reserveItem) return false;
    if (this.reserve.isCalendar && !this.reserveItem.sale_calendar) return false;
    if (this.reserve.isCalendar && this.reserveItem.sale_calendar.length === 0) return false;
    return true;
  }

  public deleteReserve(reserve: IReserveShoppingCartItem) {
    const uid = this.getUid();
    this.paymentProvider.deleteReserveFromShoppingCart(uid, reserve.id);
  }

}



// WEBPACK FOOTER //
// ./src/components/cart-reserve-item/cart-reserve-item.ts